import { t } from "@auto/services";
export const REPORT_MODES = Object.freeze({
  STANDARD: "STANDARD",
  CORRECTION: "CORRECTION",
});

export const GEOGRAPHY_LEVELS = Object.freeze([
  { value: "DEPARTMENT", label: t("person.department") },
  { value: "ARRONDISSEMENT", label: t("geo.arrondissement") },
  { value: "COMMUNE", label: t("person.commune") },
  { value: "SECTION", label: t("geo.communalSection") },
  { value: "VOTING_CENTER", label: t("voter.votingCenter") },
  { value: "CONSTITUENCY", label: t("geo.constituency") },
]);

export const STANDARD_GEOGRAPHY_METRICS = Object.freeze([
  { value: "registeredVoterCount", label: t("reporting.registeredVoters"), kind: "number" },
]);

export const CORRECTION_GEOGRAPHY_METRICS = Object.freeze([
  { value: "registeredVoterCount", label: t("reporting.registeredVoters"), kind: "number" },
]);

export const GEOJSON_FILES = Object.freeze({
  DEPARTMENT: "departments.geojson",
  ARRONDISSEMENT: "arrondissements.geojson",
  COMMUNE: "communes.geojson",
  SECTION: "sections.geojson",
  CONSTITUENCY: "constituencies.geojson",
});

export const AGE_LABELS = Object.freeze({
  UNDER_18: "reporting.under18",
  "18_28": "reporting.age18_28",
  "29_38": "reporting.age29_38",
  "39_48": "reporting.age39_48",
  "49_58": "reporting.age49_58",
  "59_68": "reporting.age59_68",
  "69_PLUS": "reporting.age69plus",
  UNKNOWN: "common.unknown",
});

export const SEX_LABELS = Object.freeze({
  M: "filter.male",
  MALE: "filter.male",
  MASCULIN: "filter.male",
  HOMME: "filter.male",
  H: "filter.male",
  F: "filter.female",
  FEMALE: "filter.female",
  FEMININ: "filter.female",
  FEMME: "filter.female",
  X: "common.other",
  OTHER: "common.other",
  AUTRE: "common.other",
  PENDING: "reporting.pendingApplications",
  UNKNOWN: "common.unknown",
});

export const STATUS_OPTIONS = Object.freeze([
  { value: 1, label: t("common.submitted") },
  { value: 2, label: t("common.reviewed") },
  { value: 3, label: t("common.rejected") },
  { value: 4, label: t("common.approved") },
]);

export const SOURCE_OPTIONS = Object.freeze([
  { value: 0, label: t("common.unknown") },
  { value: 1, label: "ONI" },
  { value: 2, label: "NFC" },
  { value: 3, label: t("reporting.manual") },
]);
